import React from "react";
import { Link } from "react-router-dom";
const AcessList = () => {
	return (
		<div className="flex flex-row  justify-center  items-center	 gap-8 min-h-screen	 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 ">
			<div>
				<Link
					to="/coursesCheck"
					className="rounded-none bg-teal-900 px-2 py-2 text-white	cursor-pointer		 "
				>
					Check Courses
				</Link>
			</div>
			<div>
				<Link
					to="/addCourses"
					className="rounded-none bg-sky-900 px-2 py-2 text-white cursor-pointer	 "
				>
					Add Courses{" "}
				</Link>
			</div>
		</div>
	);
};

export default AcessList;
